







import { Vue, Component } from 'vue-property-decorator';
import ScreenList, { Screen } from './ScreenList.vue';

@Component({
    components: {
        ScreenList,
    },
})
export default class Help extends Vue {
    private screens: Screen[] = [{ title: '利用規約', icon: 'insert_drive_file', url: 'Terms' },
    { title: 'よくある質問', icon: 'question_answer', url: 'FAQ' },
    { title: 'PROOFIT 1Dサービスについて', icon: 'info', url: 'About1dService'}];
}
